import styled, { css } from 'styled-components'

const size = css<{ size?: number }>`
	${({ size }) =>
		size &&
		css`
			width: ${size}px;
			height: ${size}px;
		`}
`

export const Loader = styled.div<{ size?: number; position?: string }>`
	${size}
	display: inline-block;
	position: relative;
	${({ position }) =>
		position &&
		css`
			${position}
		`}
`

const LoaderChildGreen = css`
	border: 2px solid #21ba72;
	border-color: #21ba72 transparent transparent transparent;
`

const LoaderChildWhite = css`
	border: 2px solid #ffffff;
	border-color: #ffffff transparent transparent transparent;
`

export const LoaderChild = styled.div<{
	color?: string
	size?: number
}>`
	${size}
	box-sizing: border-box;
	display: block;
	position: absolute;
	border-radius: 50%;
	animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
	animation-name: loader;
	&:nth-child(1) {
		animation-delay: -0.45s;
	}
	&:nth-child(2) {
		animation-delay: -0.3s;
	}
	&:nth-child(3) {
		animation-delay: -0.15s;
	}
	@keyframes loader {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
	${({ color }) => {
		switch (color) {
			case 'green':
				return LoaderChildGreen
			case 'white':
				return LoaderChildWhite
			default:
		}
	}}
`
